<button
  *ngIf="!menuItem.type || menuItem.type === 'BUTTON'"
  [disabled]="menuItem.disabled"
  (click)="menuItem.command($event)"
  [style.color]="menuItem.color"
  role="menuitem"
  [attr.aria-label]="menuItem.label"
  [pTooltip]="menuItem.label"
  tooltipPosition="top"
  [tooltipDisabled]="menuItem.showLabel"
>
  <bulb-menubar-item [menuItem]="menuItem"></bulb-menubar-item>
</button>

<ng-container *ngIf="menuItem.type === 'MENU_PANEL'" [formGroup]="formGroup">
  <bulb-menu-list-panel
    [menuItems]="menuItem.menuPanel.menuItems"
    [formControlName]="'menuListPanelControl'"
    [listType]="menuItem.menuPanel.listType"
  >
    <ng-template #buttonTemplate>
      <button
        [disabled]="menuItem.disabled"
        [style.color]="menuItem.color"
        role="menuitem"
        [attr.aria-label]="menuItem.label"
        [pTooltip]="menuItem.label"
        tooltipPosition="top"
        [tooltipDisabled]="menuItem.showLabel"
      >
        <bulb-menubar-item [menuItem]="menuItem"></bulb-menubar-item>
      </button>
    </ng-template>
  </bulb-menu-list-panel>
</ng-container>
